import { Button } from '../../catalyst/button';
import { EMPTY_MESSAGE, type EmptyState } from './emptyState';

type Props = {
  state: EmptyState;
  /** The `filtered` state's button: clears every filter. */
  onClearFilters?: () => void;
};

/** Stands in for the canvas when it has nothing to draw, in the canvas's frame, and says why. */
export function GraphEmptyState({ state, onClearFilters }: Props) {
  return (
    <div className="flex h-[70vh] min-h-[480px] flex-col items-center justify-center gap-3 rounded-lg border border-gray-200 bg-white p-4 text-center text-sm text-gray-500 lg:flex-1 lg:self-start lg:[:fullscreen_&]:h-auto lg:[:fullscreen_&]:self-stretch dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-400">
      <p>{EMPTY_MESSAGE[state]}</p>
      {onClearFilters && (
        <Button outline onClick={onClearFilters}>
          Clear filters
        </Button>
      )}
    </div>
  );
}
